import React, { useState, useEffect } from 'react';
import { Box, Container, Stack, Typography, Button } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import MailIcon from '@mui/icons-material/Mail';

// Region configuration with phone numbers
const REGION_CONFIG = {
    Canada: {
        phone: '1 (866) 992-0240'
    },
    India: {
        phone: '+91 (951) 064-9106' // Update with actual Indian number
    }
};

const Navbar = ({ onOpenContact, region: propRegion }) => {
    const [region, setRegion] = useState(propRegion || "Canada");
    const SUPPORT_EMAIL = "support@miirapos.com";

    useEffect(() => {
        // Use prop if provided, otherwise read from localStorage
        if (propRegion) {
            setRegion(propRegion);
        } else {
            const savedRegion = localStorage.getItem("api_region");
            if (savedRegion) {
                setRegion(savedRegion);
            }
        }
    }, [propRegion]);

    const PHONE_NUMBER = REGION_CONFIG[region]?.phone || REGION_CONFIG.Canada.phone;

    return (
        <Box component="nav" sx={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1100, boxShadow: '0 2px 10px rgba(0,0,0,0.05)' }}>
            
            {/* Top Contact Row */}
            <Box sx={{ background: '#1a3a5a', color: '#fff', py: 1, borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
                <Container maxWidth="lg">
                    <Stack 
                        direction={{ xs: 'column', sm: 'row' }} 
                        spacing={{ xs: 1, sm: 4 }} 
                        justifyContent="space-between" 
                        alignItems="center"
                    >
                        <Stack direction="row" spacing={3} alignItems="center">
                            <Typography 
                                variant="caption" 
                                component="a" 
                                href={`tel:${PHONE_NUMBER.replace(/\s+/g, '')}`}
                                sx={{ display: 'flex', alignItems: 'center', gap: 1, color: '#fff', textDecoration: 'none', fontWeight: 'bold', '&:hover': { color: 'tomato' } }}
                            >
                                <PhoneIcon fontSize="small" sx={{ color: 'tomato' }} /> {PHONE_NUMBER}
                            </Typography>
                            <Typography 
                                variant="caption" 
                                component="a" 
                                href={`mailto:${SUPPORT_EMAIL}`}
                                sx={{ display: 'flex', alignItems: 'center', gap: 1, color: '#fff', textDecoration: 'none', fontWeight: 'bold', '&:hover': { color: 'tomato' } }}
                            >
                                <MailIcon fontSize="small" sx={{ color: 'tomato' }} /> {SUPPORT_EMAIL}
                            </Typography>
                        </Stack>
                        
                    </Stack>
                </Container>
            </Box>

            {/* Main Navigation Bar */}
            <Box sx={{ background: '#ffffff', py: 2 }}>
                <Container maxWidth="lg">
                    <Stack direction="row" justifyContent="space-between" alignItems="center">
                        <Typography variant="h5" sx={{ fontWeight: 900, color: '#1a3a5a', letterSpacing: '1px', cursor: 'pointer' }}>
                            MiiRA<span style={{ color: 'tomato' }}>POS</span>
                        </Typography>
                        
                        <Stack direction="row" spacing={3} alignItems="center" sx={{ display: { xs: 'none', md: 'flex' } }}>
                            <Typography component="a" href="#home" sx={{ color: '#333', textDecoration: 'none', fontWeight: 500, '&:hover': { color: 'tomato' } }}>Home</Typography>
                            <Typography component="a" href="#features" sx={{ color: '#333', textDecoration: 'none', fontWeight: 500, '&:hover': { color: 'tomato' } }}>Features</Typography>
                            <Typography component="a" href="#services" sx={{ color: '#333', textDecoration: 'none', fontWeight: 500, '&:hover': { color: 'tomato' } }}>Services</Typography>
                            <Typography component="a" href="#contact" sx={{ color: '#333', textDecoration: 'none', fontWeight: 500, '&:hover': { color: 'tomato' } }}>Contact</Typography>
                        </Stack>

                        <Button 
                            variant="contained" 
                            size="medium" 
                            sx={{ background: 'tomato', color: '#fff', fontWeight: 'bold', '&:hover': { background: '#d34828' } }}
                         anchor href="/admin"
                        >
                            Login
                        </Button>
                    </Stack>
                </Container>
            </Box>
        </Box>
    );
};

export default Navbar;